import { API } from "@aws-amplify/api";

export const saveCounterParts = `mutation ($input:saveCounterPartsInput) {
    saveCounterParts(input: $input) {
    customerId
    email
    phone
    }
    }`;



export async function saveCounterPartsToDB(inputData:any): Promise<any> {
  try {
//return responseObject;
const response: any = await API.graphql({ query: saveCounterParts, variables: {input: inputData } });
console.log("SMS", response)
   return response
  } catch (error) {
    console.log("Save Counter Parts", error);
  }
}